import { store } from '@geek/yum-freight-framework'

/**
 * 浏览器标题跟随当前菜单：「页面 - 上级菜单 - 应用名」（如「电商运价 - 运价管理 - CRM」）。
 * 框架 permission.js 只给部分模块写死了标题，其余页面都是固定的「CRM」，这里在每次路由切换后按菜单路径覆盖。
 * 菜单路由是平铺的：meta.title 为菜单名，meta.parentPath 为「/上级菜单key/当前菜单key」。
 */
function findMenuTitle(menuKey) {
  if (!menuKey) return ''
  const routes = store?.state?.permission?.routes || []
  const route = routes.find((item) => item && item.name === menuKey)
  return route?.meta?.title || ''
}

export function resolveDocumentTitle(route, appName) {
  const meta = route?.meta || {}
  const keys = String(meta.parentPath || '').split('/').filter(Boolean)
  // 上级菜单在前、当前页面在后，展示时反过来：当前页面最靠前，标签页窄时也能看清
  const titles = keys.slice(0, -1).map(findMenuTitle)
  titles.push(meta.title || '')
  const parts = [...new Set(titles.filter(Boolean).reverse())]
  if (appName) parts.push(appName)
  return parts.join(' - ')
}

/** 路由切换后更新浏览器标题（在框架 beforeEach 设置的固定标题之后执行） */
export function ensureDocumentTitle(router, appName) {
  if (!router?.afterEach || router.__documentTitlePatched) return
  router.__documentTitlePatched = true
  router.afterEach((to) => {
    const title = resolveDocumentTitle(to, appName)
    if (title) document.title = title
  })
}
